module.exports = __webpack_public_path__ + "img/quantity-minus.f167efbc.svg";